<template>
  <div class="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
    <data-table :entity="'product'"
                :columns="columns"
                :data="sortedResults"
                :is-loading="loading"
                :disablePermissionChecks="true"
                operations="refresh,edit"
                rowNavigationKey="product_id"
                class="col-span-1"
                ref="table">
      <template v-slot:total="{ row }">
        <strong>{{ row.total }}</strong>
      </template>
    </data-table>
    <div class="col-span-1 bg-white overflow-hidden shadow rounded-lg mb-4 p-4 flex justify-center items-center">
      <pie-chart :chart-data="ordersPerProduct"/>
      <div v-if="(!hasData && !loading) || loading"
           class="text-lg h-20 flex items-center font-medium no-data-text">
        <i v-if="loading" class="text-primary fas fa-spinner fa-spin text-2xl"></i>
        <h3 v-if="!hasData && !loading">
          {{ $t('generic.noChartData') }}
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import orderBy from 'lodash/orderBy'
import format from 'date-fns/format'
import PieChart from 'src/components/Charts/PieChart'
import ReportService from 'src/services/ReportService'

export default {
  components: {
    PieChart
  },
  props: {
    dateFrom: {
      type: String,
      default: `${new Date().getFullYear()}-01-01`
    },
    dateTill: {
      type: String,
      default: format(new Date(), 'yyyy-MM-dd'),
    },
    job_board_id: {
      type: [String, Number],
      default: 2
    },
    allJobBoards: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      reportResults: {
        results: []
      },
      loading: false,
    }
  },
  computed: {
    ordersPerProductReport () {
      return {
        model: 'orders',
        group: 'products',
        select: 'id,total,product,job_board',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
    sortedResults () {
      return orderBy(this.reportResults.results, 'total', 'desc')
    },
    columns () {
      return [
        {
          label: this.$t('generic.product'),
          prop: 'product_name'
        },
        {
          label: this.$t('reports.totalUsed'),
          prop: 'total'
        }
      ]
    },
    ordersPerProduct () {
      let validEntries = this.reportResults.results
      if (!this.allJobBoards) {
        validEntries = validEntries.filter(r => {
          if (!r.job_board_id) {
            return
          }
          return r.job_board_id.toString() === this.job_board_id.toString()
        })
      }

      return {
        labels: validEntries.map(r => r.product_name),
        datasets: [
          {
            label: this.$t('report.products'),
            backgroundColor: ['#5145cd', '#31c48d', '#0694a2', '#F9703E', '#e02424', '#4299E1', '#667EEA', '#9F7AEA', '#D53F8C', '#38A169', '#ECC94B', '#E53E3E'],
            data: validEntries.map(r => r.total)
          }
        ]
      }
    },
    hasData () {
      return get(this.ordersPerProduct, 'datasets[0].data.length', 0) > 0
    }
  },
  methods: {
    async getReport () {
      try {
        this.loading = true
        const {data} = await ReportService.get(this.ordersPerProductReport)
        this.reportResults = data
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    dateFrom () {
      this.getReport()
    },
    dateTill () {
      this.getReport()
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>
<style scoped>
.no-data-text {
  margin-left: -400px;
}
</style>
